<app-dialog-simple
  [textContent]="{
    title: 'pop-up.annuler.texte-premiere-ligne',
    titleId: 'titre-modale',
    paragraph: 'pop-up.annuler.texte-deuxieme-ligne',
    paragraphId: 'texte-modale',
    confirmButton: 'btn.oui',
    cancelButton: 'btn.non'
  }"
  (close)="close()"
  (confirm)="confirm()"
>
</app-dialog-simple>
